/* eslint-disable */
/**
 * 描述：基类
 */
import axios from './request';

export const fetch = axios;
